import actions from "./actions";

const loadAll = force => (dispatch, getState) => {
  const theme = getState().theme;
  if (!force && (theme.isLoading || theme.isLoaded)) {
    return;
  }

  dispatch(actions.loadAll());

  fetch("/api/themes", { credentials: "include", headers: { Pragma: "no-cache", "Cache-Control":"no-cache" } })
    .then(res => {
      if (res.status === 401) {
        throw Error("Unauthorized");
      }
      return res.json();
    })
    .then(data => {
      dispatch(actions.setAll(data));
    })
    .catch(e => {
      console.log("Parsing themes failed", e);
    });
};

export default {
  loadAll,
};



// WEBPACK FOOTER //
// ./src/redux/theme/operations.js